<template>
    <vAvatar v-bind="{ size: 24, ...$attrs }" :style="'background-image: url(' + flagsPath + flag + ')'" :class="{
        'mr-3': left,
        'ml-3': right,
        'elevation-2': circular,
        'flag-icon': !circular,
    }" :is="circular ? 'v-avatar' : 'span'"></vAvatar>
</template>

<script>
import VAvatar from "vuetify/lib/components/VAvatar"; // if component is in _shared folder, vuetify components are not automatically available and must be manually imported!!!
const flagsBasePath = "/assets/flags/";
export default {
    components: { VAvatar },
    props: {
        flag: {
            type: String,
            required: true,
        },

        circular: {
            type: Boolean,
            default: true,
        },

        left: {
            type: Boolean,
            default: false,
        },

        right: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        flagsPath() {
            const folder = this.circular ? "1x1" : "4x3";
            return `${flagsBasePath}/${folder}/`;
        },
    },
};
</script>

<style lang="scss">
.flag-icon-background {
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
}

.flag-icon {
    @extend .flag-icon-background;
    position: relative;
    display: inline-block;
    width: (4 / 3) * 1em;
    line-height: 1em;

    &:before {
        content: "\00a0";
    }

    &.flag-icon-squared {
        width: 1em;
    }
}
</style>
